import { useEffect, useState } from "react";
import api from "@/lib/api";
import { LifeBuoy } from "lucide-react";
import { Thread, catLabel, statusLabel, statusCls } from "@/pages/Tickets";

export default function AdminTickets() {
  const [tickets, setTickets] = useState(null);
  const [active, setActive] = useState(null);
  const load = () => api.get("/admin/tickets").then(({ data }) => setTickets(data)).catch(() => setTickets([]));
  useEffect(() => { load(); }, []);
  const open = async (t) => { const { data } = await api.get(`/admin/tickets/${t.id}`); setActive(data); };

  if (active) return <Thread ticket={active} onBack={() => { setActive(null); load(); }} isAdmin={true} />;

  return (
    <div className="space-y-6" data-testid="admin-tickets-page">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Segnalazioni</h1>
        <p className="text-muted-foreground mt-1 text-sm">Bug, problemi, suggerimenti e richieste dagli utenti. Rispondi e l'utente riceve una email.</p>
      </div>
      <div className="bg-card rounded-xl border border-border/80 overflow-x-auto" data-testid="admin-tickets-table">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-border text-left text-xs uppercase text-muted-foreground">
            <th className="px-4 py-3 font-semibold">Oggetto</th><th className="px-4 py-3 font-semibold">Utente</th>
            <th className="px-4 py-3 font-semibold">Categoria</th><th className="px-4 py-3 font-semibold">Stato</th>
          </tr></thead>
          <tbody className="divide-y divide-border/60">
            {tickets === null ? <tr><td colSpan={4} className="px-4 py-8 text-center text-muted-foreground">Caricamento...</td></tr>
             : tickets.length === 0 ? <tr><td colSpan={4} className="px-10 py-10 text-center text-muted-foreground"><LifeBuoy className="h-10 w-10 mx-auto text-muted-foreground/30 mb-3" />Nessuna segnalazione.</td></tr>
             : tickets.map((t) => (
              <tr key={t.id} onClick={() => open(t)} className="cursor-pointer hover:bg-muted transition-colors" data-testid={`admin-ticket-row-${t.id}`}>
                <td className="px-4 py-3 font-medium flex items-center gap-2">{t.admin_unread && <span className="h-2 w-2 rounded-full bg-[#E3FF00] ring-1 ring-neutral-900 shrink-0" />}{t.subject}</td>
                <td className="px-4 py-3"><div>{t.user_name}</div><div className="text-xs text-muted-foreground">{t.user_email}</div></td>
                <td className="px-4 py-3">{catLabel(t.category)}</td>
                <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${statusCls(t.status)}`}>{statusLabel(t.status)}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
